import React, { useEffect, useRef, useState } from "react";
import parse, { domToReact } from "html-react-parser";

interface IProps {
    alertDetails?: any;
}

const AlertDetailsComponent: React.FunctionComponent<IProps> = (props) => {
    const [json, setJson] = useState<any>([]);

    useEffect(() => {
        let data = JSON.parse(props.alertDetails?.rawContentUrl);
        let bundleComponent = data.BundleComponents?.BundleComponent;
        //bundleComponent.Type = objectToString(bundleComponent.Type);
        setJson(bundleComponent);
    }, []);

    const objectToString = (jsonObj: any) => {
        if (typeof jsonObj === "object" && jsonObj.hasOwnProperty("$")) {
            return jsonObj["$"];
        }
        return jsonObj;
    };

    const append_table = (table: any, value: any, label: any) => {
        // return table + "<div class='item'> <div class='title'>" + value + "</div><div class='detail'>" + label + "</div></div>";
        return (
            table +
            "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label'>" +
            value +
            "</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
            label +
            "</div></div></div></div>"
        );
    };

    const time_stamp = (date: any) => {
        if ("undefined" == typeof date) {
            return "N/A";
        }
        if ("undefined" != typeof date["xsi:nil"]) {
            return "N/A";
        }
        var seconds = 0;
        var minutes = 0;
        var hours = 0;
        //check for time
        var n = date.indexOf("-", 8);

        var dateArr = date.split(/[- :]/);

        var day = parseInt(dateArr[2]);
        if (day < 10) day = Number("0" + day);

        var month = parseInt(dateArr[1]);
        if (month < 10) month = Number("0" + month);

        var year = parseInt(dateArr[0]);

        if ("undefined" != typeof dateArr[3]) hours = parseInt(dateArr[3]);
        if (hours < 10) hours = Number("0" + hours);

        if ("undefined" != typeof dateArr[4]) minutes = parseInt(dateArr[4]);
        if (minutes < 10) minutes = Number("0" + minutes);

        if ("undefined" != typeof dateArr[5]) seconds = parseInt(dateArr[5]);
        if (seconds < 10) seconds = Number("0" + seconds);

        if (n > -1) var string_time_stamp = month + "/" + day + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
        else var string_time_stamp = month + "/" + day + "/" + year;

        return string_time_stamp;
    };

    const append_header = (table: any, type: any, bureau: any) => {
        var bur = "";
        if (bureau == "TUC") {
            bur = "TransUnion";
        } else if (bureau == "EXP") {
            bur = "Experian";
        } else if (bureau == "EQF") {
            bur = "Equifax";
        } else if (bureau == "TUCAN") {
            bur = "TransUnionCA";
        } else {
            bur = bureau;
        }
        //return table + "<div class='header-container'><div class='header'>" + bur + " - " + type + "</div><div class='separator'></div></div><div class='container'>";
        //return table + "<div role='row' class='data-row row'><div role='gridcell' class='col-12 col-no-gutter'><div class='data-label' id='alert1-address'>" + bur + " - " + type + "</div></div></div>"
        return "";
    };

    const close_container = (table: any) => {
        return table + "</div>";
    };

    const description = () => {
        /*var desc = "As part of your identity protection service, we monitor your personal information for potential fraud and theft. This information includes your name, social security number, address, phone number and date of birth. Please review the following information carefully keeping in mind that legitimate activity can sometimes trigger an alert.";
        //var HTML = "<div class='description'>" + desc + "</div>"
        var HTML = "<div role='row' class='data-row row'><div role='gridcell' class='col-12 col-no-gutter'><div class='data-value' id='alert1-address'>" + desc + "</div></div></div>";
        return HTML;*/
        return "";
    };

    const getStringData = (jsonData: any, property: any) => {
        if ("undefined" == typeof jsonData || jsonData.hasOwnProperty("xsi:nil")) {
            return "N/A";
        } else if ("" == property) {
            return jsonData;
        } else {
            if ("undefined" != typeof jsonData[property] && !jsonData[property].hasOwnProperty("xsi:nil")) {
                return jsonData[property];
            } else {
                return "N/A";
            }
        }
    };

    const address_table = (address: any) => {
        if ("undefined" == typeof address || address.hasOwnProperty("xsi:nil")) {
            //return "<div class='item'><div class='title'>Address</div><div class='detail'>N/A</div></div>";
            return "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address1'>Address</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>N/A</div></div></div></div>";
        }
        var HTML = "";
        //HTML = "<div class='item'><div class='title'>Address</div><div class='detail'>" + getStringData(address, "d3p1:StreetAddressLineOne") + "</div></div>";
        if(address["d3p1:StreetAddressLineOne"]) {
            HTML =
               HTML +
              "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address2'>Address </div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
              getStringData(address, "d3p1:StreetAddressLineOne") +
             "</div></div></div></div>";
        } 
        if (address["d3p1:StreetAddressLineTwo"] && !address["d3p1:StreetAddressLineTwo"].hasOwnProperty("xsi:nil")) {
            // HTML = HTML + "<div class='item'><div class='title'>Address 2</div><div class='detail'>" + getStringData(address, "d3p1:StreetAddressLinetwo") + "</div></div>";
            HTML =
                HTML +
                "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address3'>Address 2</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
                getStringData(address, "d3p1:StreetAddressLinetwo") +
                "</div></div></div></div>";
        }
           
        // HTML = HTML + "<div class='item'><div class='title'>City</div><div class='detail'>" + getStringData(address, "d3p1:City") + "</div></div>";
        HTML =
            HTML +
            "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address4'>City</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
            getStringData(address, "d3p1:City") +
            "</div></div></div></div>";

        // HTML = HTML + "<div class='item'><div class='title'>Zip</div><div class='detail'>" + getStringData(address, "d3p1:Zip") + "</div></div>";
        HTML =
            HTML +
            "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address5'>Zip</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
            getStringData(address, "d3p1:Zip") +
            "</div></div></div></div>";

        // HTML = HTML + "<div class='item'><div class='title'>State</div><div class='detail'>" + getStringData(address, "d3p1:State") + "</div></div>";
        HTML =
            HTML +
            "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address6'>State</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
            getStringData(address, "d3p1:State") +
            "</div></div></div></div>";
        return HTML;
    };

    const phone_table = (phone: any) => {
        if ("undefined" == typeof phone || phone.hasOwnProperty("xsi:nil")) {
            //return "<div class='item'><div class='title'>Phone</div><div class='detail'>N/A</div></div>";
            return "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address7'>Phone</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>N/A</div></div></div></div>";
        }
        var HTML = "";
        var phoneArea = getStringData(phone, "d3p1:AreaCode");
        var phoneNum = getStringData(phone, "d3p1:Number");
        if (phoneArea == "N/A" && phoneNum == "N/A") {
            //return "<div class='item'><div class='title'>Phone</div><div class='detail'>N/A</div></div>";
            return "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address8'>Phone</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>N/A</div></div></div></div>";
        }
        // HTML = HTML + "<div class='item'><div class='title'>Phone</div><div class='detail'>" + (phoneArea != "N/A" ? phoneArea + "-" : "") + phoneNum + "</div></div>";
        HTML =
            HTML +
            "<div role='row' class='data-row row'><div role='gridcell' class='col-xs-12 col-sm-4 col-no-gutter'><div class='data-label' id='alert1-address9'>Phone</div></div><div role='gridcell' class='col-xs-12 col-sm-8 col-no-gutter'><div class='data-value'>" +
            (phoneArea != "N/A" ? phoneArea + "-" : "") +
            phoneNum +
            "</div></div></div></div>";
        return HTML;
    };

    const maskAcctNum = (acctNum: any) => {
        var tmpAcctNum = acctNum;
        var acctNumLen = acctNum.length;
        if (acctNumLen <= 4) {
            tmpAcctNum = Array(acctNumLen).join("*") + acctNum.slice(-1);
        } else if (acctNumLen > 4 && acctNumLen <= 7) {
            tmpAcctNum = Array(acctNumLen - 1).join("*") + acctNum.slice(-2);
        } else if (acctNumLen > 7 && acctNumLen <= 12) {
            tmpAcctNum = Array(acctNumLen - 3).join("*") + acctNum.slice(-4);
        } else {
            tmpAcctNum = acctNum.substr(0, 4) + Array(acctNumLen - 7).join("*") + acctNum.slice(-4);
        }
        return tmpAcctNum;
    };

    const getAlertCat = (bureauPrefix: string) => {
        let alertCat = "";
        if (alertCat === "ImprovedTrade") {
            alertCat = "ImprovedAccount";
        }

        if (alertCat === "NewSuitJudgment") {
            alertCat = "NewSuitOrJudgment";
        }

        if (alertCat === "SuitJudgmentChange") {
            alertCat = "SuitOrJudgmentChange";
        }

        if (alertCat === "NewInquiry" && bureauPrefix === "EQF") {
            alertCat = "Inquiry";
        }

        if (alertCat === "NewTrade" && (bureauPrefix === "TUC" || bureauPrefix === "TUCAN" || bureauPrefix === "EQF")) {
            alertCat = "NewAccount";
        }

        if (alertCat === "NewAddress" && bureauPrefix === "EXP") {
            alertCat = "NewUnconfirmedAddress";
        }

        if (alertCat === "FraudOrVictimStatement" && (bureauPrefix === "TUC" || bureauPrefix === "TUCAN")) {
            alertCat = "FraudAlert";
        }

        if (alertCat === "TradeBankrupt" && bureauPrefix === "EXP") {
            alertCat = "TradelineBankruptcy";
        }

        if (alertCat === "TradeBankrupt" && (bureauPrefix === "TUC" || bureauPrefix === "TUCAN")) {
            alertCat = "NewBankruptcy";
        }

        if (alertCat === "LostStolenCard" && bureauPrefix === "EXP") {
            alertCat = "LostOrStolenCard";
        }

        if (alertCat === "PublicBankrupt" && bureauPrefix === "EXP") {
            alertCat = "PublicRecordBankruptcy";
        }

        if (alertCat === "UnknownStatus" && bureauPrefix === "EXP") {
            alertCat = "SkipCannotLocate";
        }

        return alertCat;
    };

    const htmlData = () => {
        let HTMLTable: any = "";
        var HTMLHead: any = "";

        var bureauPrefixes = ["TUC", "EQF", "EXP", "TUCAN"];

        var Alert: any = [];
        var BureauAlert: any = [];

        let BundleComponent = json;
        if (BundleComponent && "undefined" == typeof BundleComponent.length) {
            var tmpBundle = new Array();
            tmpBundle.push(BundleComponent);
            BundleComponent = tmpBundle;
        }

        for (const bureauPrefix of bureauPrefixes) {
            var alertCat = getAlertCat(bureauPrefix);

            var detailVar = "d3p1:" + bureauPrefix + "AlertDetail";
            if (bureauPrefix == "TUC") {
                detailVar = "d3p1:" + bureauPrefix + "AlertsDetail";
            } else if (bureauPrefix == "TUCAN") {
                detailVar = "d3p1:" + bureauPrefix + "AlertDetails";
            }

            for (let i = 0; BundleComponent && i < BundleComponent.length; i++) {
                let subComponent = BundleComponent[i];

                var Alerts = subComponent?.GetAlertsResponseSuccess?.Alerts?.AlertType;
                let type = objectToString(subComponent.Type);

                if (Alerts && type == bureauPrefix + "AlertDetails") {
                    /*
                     * var alertIndex = Alerts.length - 1;
                    if ("undefined" != typeof alertOrder && parseInt(alertOrder) > 0) {
                        alertIndex = alertOrder - 1;
                    }*/

                    if ("undefined" == typeof Alerts.length) {
                        var tmpAlerts = new Array();
                        tmpAlerts.push(Alerts);
                        Alerts = tmpAlerts;
                    }
                    var alertIndex = Alerts.length - 1;

                    if (alertCat != "") {
                        var aIdx = 0;

                        for (var k = 0; k < Alerts.length; k++) {
                            var tmpAlert = Alerts[k];
                            if (
                                "undefined" != typeof tmpAlert["d3p1:" + bureauPrefix + "Alert"] &&
                                "undefined" != typeof tmpAlert["d3p1:" + bureauPrefix + "Alert"][detailVar] &&
                                "undefined" != typeof tmpAlert["d3p1:" + bureauPrefix + "Alert"][detailVar]["d3p1:" + alertCat]
                            ) {
                                if (aIdx == alertIndex) {
                                    Alert = tmpAlert;
                                    break;
                                }

                                aIdx++;
                            }
                        }
                    } else {
                        Alert = Alerts[alertIndex];
                    }

                    BureauAlert = Alert["d3p1:" + bureauPrefix + "Alert"];
                    if (bureauPrefix == "TUCAN") {
                        BureauAlert = Alert["d3p1:GenericAlert"];
                    }

                    if (
                        BureauAlert &&
                        (BureauAlert[detailVar] ||
                            ("TUCAN" == bureauPrefix && BureauAlert["d3p1:Bureau"] && BureauAlert["d3p1:GAElement"] && BureauAlert["d3p1:GAGroup"]))
                    ) {
                        if (
                            "TUC" === bureauPrefix &&
                            BureauAlert[detailVar] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:Settlement"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:MajorDerogatory"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NameChange"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NewSuitOrJudgment"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:SuitOrJudgmentChange"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:Inquiry"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:AccountInformation"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NewTrade"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:Delinquent"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:FraudOrVictimStatement"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:CollectionChange"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NewCollection"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:CardOverLimit"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:ChangeOfAddress"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NewUnconfirmedAddress"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:NewTaxLien"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:TaxLienChange"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:LiensAndJudgments"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:TradelineBankruptcy"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:LostOrStolenCard"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:PublicRecordBankruptcy"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:SkipCannotLocate"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:Deceased"] &&
                            "undefined" == typeof BureauAlert[detailVar]["d3p1:BankruptcyChange"]
                        ) {
                            if (!BureauAlert[detailVar]["d3p1:GenericAlert"]) {
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(BureauAlert["d3p1:AvailableDate"]));
                            }
                        } else if ("TUCAN" == bureauPrefix && BureauAlert["d3p1:GAElement"]) {
                            let availableDate = "";
                            let FraudIndicator = false;
                            for (let el in BureauAlert["d3p1:GAElement"]) {
                                let subObj = BureauAlert["d3p1:GAElement"][el];
                                if (objectToString(subObj["d3p1:Key"]) == "AvailableDate") {
                                    availableDate = objectToString(subObj["d3p1:Value"]);
                                } else if (objectToString(subObj["d3p1:Key"]) == "FraudIndicator") {
                                    FraudIndicator = objectToString(subObj["d3p1:Value"]);
                                }
                            }

                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(availableDate));

                            if ("TUCAN" == bureauPrefix && FraudIndicator) {
                                HTMLHead = append_header(HTMLHead, "FRAUD ALERT", bureauPrefix);
                                HTMLTable = close_container(HTMLTable);
                            }
                        }

                        let TUCBureauAlert = Alert["d3p1:" + bureauPrefix + "Alert"];
                        if (TUCBureauAlert && TUCBureauAlert.FraudIndicator == "true") {
                            HTMLHead = append_header(HTMLHead, "FRAUD ALERT", bureauPrefix);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if ("TUCAN" == bureauPrefix && BureauAlert["d3p1:GAGroup"]) {
                            let grpElement = BureauAlert["d3p1:GAGroup"]["d3p1:GAElement"];
                            let alertType = "";

                            grpElement = grpElement.constructor.name == "Array" ? grpElement : [grpElement];

                            if (grpElement) {
                                for (let el in grpElement) {
                                    let subObj = grpElement[el];

                                    if (objectToString(subObj["d3p1:Key"]) == "AlertType") {
                                        HTMLHead = append_header(HTMLHead, objectToString(subObj["d3p1:Value"]).replace(/([A-Z])/g, " $1"), bureauPrefix);
                                        alertType = objectToString(subObj["d3p1:Value"]);
                                    } else if (objectToString(subObj["d3p1:Key"]) != null && objectToString(subObj["d3p1:Value"]) != null) {
                                        HTMLTable = append_table(
                                            HTMLTable,
                                            objectToString(subObj["d3p1:Key"]).replace(/([A-Z])/g, " $1"),
                                            objectToString(subObj["d3p1:Value"])
                                        );
                                    }
                                }
                                HTMLTable = close_container(HTMLTable);
                            }
                        }
                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:GenericAlert"]) {
                            const genericAlertDetails = BureauAlert[detailVar]["d3p1:GenericAlert"];
                            HTMLHead += description();
                            const gaElement = getStringData(genericAlertDetails, "d3p1:GAElement");
                            if (getStringData(genericAlertDetails, "d3p1:Bureau")) {
                                HTMLTable = append_table(HTMLTable, "Credit Bureau", getStringData(genericAlertDetails, "d3p1:Bureau"));
                            }
                            if (gaElement && gaElement.length) {
                                for (let i = 0; i < gaElement.length; i++) {
                                    const elem = gaElement[i];
                                    HTMLTable = append_table(HTMLTable, elem["d3p1:Key"], elem["d3p1:Value"]);
                                }
                            }
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewInquiry"]) {
                            HTMLHead = append_header(HTMLHead, "New Inquiry", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewInquiry"];
                            if ("EXP" === bureauPrefix) {
                                HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                            } else {
                                if ("undefined" != alertDetails["d3p1:InquireeAddress"]
                                && !("undefined" == typeof alertDetails["d3p1:InquireeAddress"] || alertDetails["d3p1:InquireeAddress"]?.hasOwnProperty("xsi:nil")) ) 
                                 {
                                    HTMLTable = HTMLTable + address_table(alertDetails["d3p1:InquireeAddress"]);
                                }
                                HTMLTable = append_table(HTMLTable, "Inquirer Name", getStringData(alertDetails, "d3p1:InquirerName"));
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:PhoneNumber"]);
                                HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                                if ("undefined" != alertDetails["d3p1:SubscriberAddres"]) {
                                    HTMLTable = HTMLTable + address_table(alertDetails["d3p1:SubscriberAddres"]);
                                } else if ("undefined" != alertDetails["d3p1:SubscriberAddress"]) {
                                    HTMLTable = HTMLTable + address_table(alertDetails["d3p1:SubscriberAddress"]);
                                }
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewTrade"]) {
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewTrade"];
                            HTMLHead = append_header(HTMLHead, getStringData(alertDetails, "d3p1:AlertType"), bureauPrefix);
                            HTMLHead += description();
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                            HTMLTable = append_table(HTMLTable, "Open Date", time_stamp(alertDetails["d3p1:OpenDate"]));
                            HTMLTable = append_table(HTMLTable, "Credit Limit", getStringData(alertDetails, "d3p1:CreditLimit"));
                            HTMLTable = append_table(HTMLTable, "Balance", getStringData(alertDetails, "d3p1:Balance"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewEmployment"]) {
                            HTMLHead = append_header(HTMLHead, "New Employment", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewEmployment"];
                            HTMLTable = append_table(HTMLTable, "Employer Name", getStringData(alertDetails, "d3p1:EmployerName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = append_table(HTMLTable, "Hourly Wage", getStringData(alertDetails, "d3p1:HourlyWage"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewPublicRecord"]) {
                            HTMLHead = append_header(HTMLHead, "New Public Record", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewPublicRecord"];
                            HTMLTable = append_table(HTMLTable, "Public Record Type", getStringData(alertDetails, "d3p1:PublicRecordType"));
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = append_table(HTMLTable, "Reference Number", getStringData(alertDetails, "d3p1:ReferenceNumber"));
                            HTMLTable = append_table(HTMLTable, "Closing Date", time_stamp(alertDetails["d3p1:ClosingDate"]));
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = append_table(HTMLTable, "Plaintiff", getStringData(alertDetails, "d3p1:Plaintiff"));
                            HTMLTable = append_table(HTMLTable, "Liability Amount", getStringData(alertDetails, "d3p1:LiabilityAmount"));
                            HTMLTable = append_table(HTMLTable, "Asset Amount", getStringData(alertDetails, "d3p1:AssetAmount"));
                            HTMLTable = append_table(HTMLTable, "Status", getStringData(alertDetails, "d3p1:Status"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:ImprovedAccount"]) {
                            HTMLHead = append_header(HTMLHead, "Improved Account", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:ImprovedAccount"];
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:PhoneNumber"]);
                            HTMLTable = append_table(HTMLTable, "Amount Delinquent", getStringData(alertDetails, "d3p1:AmountDelinquent"));
                            HTMLTable = append_table(HTMLTable, "Account Balance", getStringData(alertDetails, "d3p1:AccountBalance"));
                            HTMLTable = append_table(HTMLTable, "Payment Status", getStringData(alertDetails, "d3p1:PaymentStatus"));
                            HTMLTable = append_table(HTMLTable, "Creditor Preferred Contact", getStringData(alertDetails, "d3p1:CreditorPreferredContact"));
                            HTMLTable = append_table(HTMLTable, "Consumer Statement", getStringData(alertDetails, "d3p1:ConsumerStatement"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:DelinquentAccount"]) {
                            HTMLHead = append_header(HTMLHead, "Delinquent Account", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:DelinquentAccount"];
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:PhoneNumber"]);
                            HTMLTable = append_table(HTMLTable, "Amount Delinquent", getStringData(alertDetails, "d3p1:AmountDelinquent"));
                            HTMLTable = append_table(HTMLTable, "Account Balance", getStringData(alertDetails, "d3p1:AccountBalance"));
                            HTMLTable = append_table(HTMLTable, "Payment Status", getStringData(alertDetails, "d3p1:PaymentStatus"));
                            HTMLTable = append_table(HTMLTable, "Creditor Preferred Contact", getStringData(alertDetails, "d3p1:CreditorPreferredContact"));
                            HTMLTable = append_table(HTMLTable, "Consumer Statement", getStringData(alertDetails, "d3p1:ConsumerStatement"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewAccount"]) {
                            HTMLHead = append_header(HTMLHead, "New Account", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewAccount"];
                            if (bureauPrefix == "EQF") {
                                HTMLTable = append_table(HTMLTable, "Date Opened", time_stamp(alertDetails["d3p1:DateOpened"]));
                            }
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:PhoneNumber"]);
                            HTMLTable = append_table(HTMLTable, "Amount Delinquent", getStringData(alertDetails, "d3p1:AmountDelinquent"));
                            HTMLTable = append_table(HTMLTable, "Account Balance", getStringData(alertDetails, "d3p1:AccountBalance"));
                            HTMLTable = append_table(HTMLTable, "Payment Status", getStringData(alertDetails, "d3p1:PaymentStatus"));
                            HTMLTable = append_table(HTMLTable, "Creditor Preferred Contact", getStringData(alertDetails, "d3p1:CreditorPreferredContact"));
                            HTMLTable = append_table(HTMLTable, "Consumer Statement", getStringData(alertDetails, "d3p1:ConsumerStatement"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewBankruptcy"]) {
                            HTMLHead = append_header(HTMLHead, "New Bankruptcy", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewBankruptcy"];
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:FraudAlert"]) {
                            HTMLHead = append_header(HTMLHead, "Fraud Alert", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:FraudAlert"];
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = append_table(
                                HTMLTable,
                                "Comments",
                                getStringData(alertDetails, "d3p1:Comments")
                                    .split(":")[0]
                                    .replace(/([^.])$/, "$1.")
                            );
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:Settlement"]) {
                            HTMLHead = append_header(HTMLHead, "Settlement", bureauPrefix);
                            HTMLHead += description();
                            if (BureauAlert[detailVar]["d3p1:Settlement"]["d3p1:" + bureauPrefix + "Derogatory"]) {
                                var alertDetails = BureauAlert[detailVar]["d3p1:Settlement"]["d3p1:" + bureauPrefix + "Derogatory"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                                HTMLTable = append_table(HTMLTable, "Settlement Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:MajorDerogatory"]) {
                            HTMLHead = append_header(HTMLHead, "Major Derogatory", bureauPrefix);
                            HTMLHead += description();
                            if (BureauAlert[detailVar]["d3p1:MajorDerogatory"]["d3p1:" + bureauPrefix + "Derogatory"]) {
                                var alertDetails = BureauAlert[detailVar]["d3p1:MajorDerogatory"]["d3p1:" + bureauPrefix + "Derogatory"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                                HTMLTable = append_table(HTMLTable, "Major Derogatory Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NameChange"]) {
                            HTMLHead = append_header(HTMLHead, "Name Change", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NameChange"];
                            HTMLTable = append_table(HTMLTable, "First Name", getStringData(alertDetails, "d3p1:FirstName"));
                            HTMLTable = append_table(HTMLTable, "Middle Name", getStringData(alertDetails, "d3p1:MiddleName"));
                            HTMLTable = append_table(HTMLTable, "Last Name", getStringData(alertDetails, "d3p1:LastName"));
                            HTMLTable = append_table(HTMLTable, "Suffix", getStringData(alertDetails, "d3p1:NameSuffix"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewSuitOrJudgment"]) {
                            HTMLHead = append_header(HTMLHead, "New Suit or Judgment", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewSuitOrJudgment"];
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            HTMLTable = append_table(HTMLTable, "Case Number", getStringData(alertDetails, "d3p1:CaseNumber"));
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Date Satisfied", time_stamp(alertDetails["d3p1:DateSatisfied"]));
                            HTMLTable = append_table(HTMLTable, "Plaintiff", getStringData(alertDetails, "d3p1:Plaintiff"));
                            HTMLTable = append_table(HTMLTable, "Defendant", getStringData(alertDetails, "d3p1:Defendant"));
                            HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = append_table(HTMLTable, "Status", getStringData(alertDetails, "d3p1:Status"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:SuitOrJudgmentChange"]) {
                            HTMLHead = append_header(HTMLHead, "Suit or Judgment Change", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:SuitOrJudgmentChange"];
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            HTMLTable = append_table(HTMLTable, "Case Number", getStringData(alertDetails, "d3p1:CaseNumber"));
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Date Satisfied", time_stamp(alertDetails["d3p1:DateSatisfied"]));
                            HTMLTable = append_table(HTMLTable, "Plaintiff", getStringData(alertDetails, "d3p1:Plaintiff"));
                            HTMLTable = append_table(HTMLTable, "Defendant", getStringData(alertDetails, "d3p1:Defendant"));
                            HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = append_table(HTMLTable, "Status", getStringData(alertDetails, "d3p1:Status"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:Inquiry"]) {
                            HTMLHead = append_header(HTMLHead, "New Inquiry", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:Inquiry"];
                            HTMLTable = append_table(HTMLTable, "Inquirer Name", getStringData(alertDetails, "d3p1:InquirerName"));
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:InquirerPhone"]);
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:InquirerAddress"]);
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = append_table(HTMLTable, "Inquiry Abbreviation", getStringData(alertDetails, "d3p1:InquiryAbbreviation"));
                            HTMLTable = append_table(HTMLTable, "Inquiry Intent", getStringData(alertDetails, "d3p1:InquiryIntent"));
                            HTMLTable = append_table(HTMLTable, "Inquiry Date", time_stamp(alertDetails["d3p1:InquiryDate"]));
                            HTMLTable = append_table(HTMLTable, "End User Text", getStringData(alertDetails, "d3p1:EndUserText"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:AccountInformation"]) {
                            HTMLHead = append_header(HTMLHead, "Account Information", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:AccountInformation"];
                            HTMLTable = append_table(HTMLTable, "Date Opened", time_stamp(alertDetails["d3p1:DateOpened"]));
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:Phone"]);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:Delinquent"]) {
                            HTMLHead = append_header(HTMLHead, "Delinquency", bureauPrefix);
                            HTMLHead += description();
                            if (BureauAlert[detailVar]["d3p1:Delinquent"]["d3p1:" + bureauPrefix + "Derogatory"]) {
                                var alertDetails = BureauAlert[detailVar]["d3p1:Delinquent"]["d3p1:" + bureauPrefix + "Derogatory"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                                HTMLTable = append_table(HTMLTable, "Delinquency Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                                HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:FraudOrVictimStatement"]) {
                            HTMLHead = append_header(HTMLHead, "Fraud or Victim Statement", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:FraudOrVictimStatement"];
                            HTMLTable = append_table(HTMLTable, "Fraud Alert Type", getStringData(alertDetails, "d3p1:AlertType"));
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:CollectionChange"]) {
                            HTMLHead = append_header(HTMLHead, "Collection Change", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:CollectionChange"];
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Status", getStringData(alertDetails, "d3p1:Status"));
                            HTMLTable = append_table(HTMLTable, "Original Amount", getStringData(alertDetails, "d3p1:OriginalAmount"));
                            HTMLTable = append_table(HTMLTable, "Balance", getStringData(alertDetails, "d3p1:BalanceAmount"));
                            HTMLTable = append_table(HTMLTable, "Date of Last Payment", time_stamp(alertDetails["d3p1:DateOfLastPayment"]));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:Phone"]);
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:CardOverLimit"]) {
                            HTMLHead = append_header(HTMLHead, "Card Over Limit", bureauPrefix);
                            HTMLHead += description();
                            if (BureauAlert[detailVar]["d3p1:CardOverLimit"]["d3p1:" + bureauPrefix + "Derogatory"]) {
                                var alertDetails = BureauAlert[detailVar]["d3p1:CardOverLimit"]["d3p1:" + bureauPrefix + "Derogatory"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                                HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                                HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewCollection"]) {
                            HTMLHead = append_header(HTMLHead, "New Collection", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewCollection"];
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "AccountNumber", maskAcctNum(getStringData(alertDetails, "d3p1:AccountNumber")));
                            HTMLTable = append_table(HTMLTable, "Status", getStringData(alertDetails, "d3p1:Status"));
                            HTMLTable = append_table(HTMLTable, "Original Amount", getStringData(alertDetails, "d3p1:OriginalAmount"));
                            HTMLTable = append_table(HTMLTable, "Balance", getStringData(alertDetails, "d3p1:BalanceAmount"));
                            HTMLTable = append_table(HTMLTable, "Date of Last Payment", time_stamp(alertDetails["d3p1:DateOfLastPayment"]));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:Phone"]);
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewAddress"]) {
                            HTMLHead = append_header(HTMLHead, "New Address", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewAddress"];
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewUnconfirmedAddress"]) {
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewUnconfirmedAddress"];
                            HTMLHead = append_header(HTMLHead, getStringData(alertDetails, "d3p1:AlertType"), bureauPrefix);
                            HTMLHead += description();
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:NewAddress"]);
                            HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:ChangeOfAddress"]) {
                            HTMLHead = append_header(HTMLHead, "Change Of Address", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:ChangeOfAddress"];
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = append_table(HTMLTable, "Date Reported", time_stamp(alertDetails["d3p1:DateReported"]));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:NewTaxLien"]) {
                            HTMLHead = append_header(HTMLHead, "New Tax Lien", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:NewTaxLien"];
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = append_table(HTMLTable, "Creditor Class", getStringData(alertDetails, "d3p1:CreditorClass"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            HTMLTable = append_table(HTMLTable, "Case Number", getStringData(alertDetails, "d3p1:CaseNumber"));
                            HTMLTable = append_table(HTMLTable, "Release Date", time_stamp(alertDetails["d3p1:ReleaseDate"]));
                            HTMLTable = append_table(HTMLTable, "Verification Date", time_stamp(alertDetails["d3p1:VerificationDate"]));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:TaxLienChange"]) {
                            HTMLHead = append_header(HTMLHead, "Tax Lien Change", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:TaxLienChange"];
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = append_table(HTMLTable, "Creditor Class", getStringData(alertDetails, "d3p1:CreditorClass"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            HTMLTable = append_table(HTMLTable, "Case Number", getStringData(alertDetails, "d3p1:CaseNumber"));
                            HTMLTable = append_table(HTMLTable, "Release Date", time_stamp(alertDetails["d3p1:ReleaseDate"]));
                            HTMLTable = append_table(HTMLTable, "Verification Date", time_stamp(alertDetails["d3p1:VerificationDate"]));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:LiensAndJudgments"]) {
                            HTMLHead = append_header(HTMLHead, "Liens And Judgments", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:LiensAndJudgments"];
                            if (BureauAlert[detailVar]["d3p1:LiensAndJudgments"]["d3p1:" + bureauPrefix + "PublicRecord"]) {
                                var alertSubDetails = BureauAlert[detailVar]["d3p1:LiensAndJudgments"]["d3p1:" + bureauPrefix + "PublicRecord"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertSubDetails["d3p1:DateOfAlert"]));
                                HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertSubDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertSubDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertSubDetails, "d3p1:CreditorType"));
                                HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertSubDetails, "d3p1:CourtName"));
                                HTMLTable = HTMLTable + address_table(alertSubDetails["d3p1:CourtAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertSubDetails["d3p1:CourtPhone"]);
                                HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertSubDetails["d3p1:DateFiled"]));
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:TradelineBankruptcy"]) {
                            HTMLHead = append_header(HTMLHead, "Tradeline Bankruptcy", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:TradelineBankruptcy"];
                            HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertDetails, "d3p1:AlertType"));
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = append_table(HTMLTable, "Industry Type", getStringData(alertDetails, "d3p1:IndustryType"));
                            HTMLTable = append_table(HTMLTable, "Bankruptcy Amount", getStringData(alertDetails, "d3p1:BankruptcyAmount"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:Address"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:Phone"]);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:LostOrStolenCard"]) {
                            HTMLHead = append_header(HTMLHead, "Lost Or Stolen Card", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:LostOrStolenCard"];
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertDetails, "d3p1:AlertType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Type", getStringData(alertDetails, "d3p1:CreditorType"));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                            HTMLTable = append_table(HTMLTable, "Last Update Date", time_stamp(alertDetails["d3p1:LastUpdateDate"]));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:PublicRecordBankruptcy"]) {
                            HTMLHead = append_header(HTMLHead, "Public Record Bankruptcy", bureauPrefix);
                            HTMLHead += description();
                            if (BureauAlert[detailVar]["d3p1:PublicRecordBankruptcy"]["d3p1:" + bureauPrefix + "PublicRecord"]) {
                                var alertDetails = BureauAlert[detailVar]["d3p1:PublicRecordBankruptcy"]["d3p1:" + bureauPrefix + "PublicRecord"];
                                HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:DateOfAlert"]));
                                HTMLTable = append_table(HTMLTable, "Alert Sub Type", getStringData(alertDetails, "d3p1:AlertType"));
                                HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                                HTMLTable = append_table(HTMLTable, "Amount", getStringData(alertDetails, "d3p1:Amount"));
                                HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                                HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                                HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            }
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:SkipCannotLocate"]) {
                            HTMLHead = append_header(HTMLHead, "Unknown Status: Please contact Creditor.", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:SkipCannotLocate"];
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = append_table(HTMLTable, "Creditor Name", getStringData(alertDetails, "d3p1:CreditorName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CreditorAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CreditorPhone"]);
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:Deceased"]) {
                            var alertDetails = BureauAlert[detailVar]["d3p1:Deceased"];
                            HTMLHead = append_header(HTMLHead, getStringData(alertDetails, "d3p1:AlertType"), bureauPrefix);
                            HTMLHead += description();
                            HTMLTable = append_table(HTMLTable, "Alert Date", time_stamp(alertDetails["d3p1:AlertDate"]));
                            HTMLTable = append_table(HTMLTable, "Date of Death", time_stamp(alertDetails["d3p1:DateOfDeath"]));
                            HTMLTable = close_container(HTMLTable);
                        }

                        if (BureauAlert[detailVar] && BureauAlert[detailVar]["d3p1:BankruptcyChange"]) {
                            HTMLHead = append_header(HTMLHead, "Bankruptcy Change", bureauPrefix);
                            HTMLHead += description();
                            var alertDetails = BureauAlert[detailVar]["d3p1:BankruptcyChange"];
                            HTMLTable = append_table(HTMLTable, "Date Filed", time_stamp(alertDetails["d3p1:DateFiled"]));
                            HTMLTable = append_table(HTMLTable, "Bankruptcy Type", getStringData(alertDetails, "d3p1:Type"));
                            HTMLTable = append_table(HTMLTable, "Court Name", getStringData(alertDetails, "d3p1:CourtName"));
                            HTMLTable = HTMLTable + address_table(alertDetails["d3p1:CourtAddress"]);
                            HTMLTable = HTMLTable + phone_table(alertDetails["d3p1:CourtPhone"]);
                            HTMLTable = append_table(HTMLTable, "Case Number", getStringData(alertDetails, "d3p1:CaseNumber"));
                            HTMLTable = append_table(HTMLTable, "Disposition Date", time_stamp(alertDetails["d3p1:DispositionDate"]));
                            HTMLTable = append_table(HTMLTable, "Liability Amount", getStringData(alertDetails, "d3p1:LiabilityAmount"));
                            HTMLTable = append_table(HTMLTable, "Asset Amount", getStringData(alertDetails, "d3p1:AssetAmount"));
                            HTMLTable = append_table(HTMLTable, "Exempt Amount", getStringData(alertDetails, "d3p1:ExemptAmount"));
                            HTMLTable = append_table(HTMLTable, "Comments", getStringData(alertDetails, "d3p1:Comments"));
                            HTMLTable = close_container(HTMLTable);
                        }
                    }
                    // $('#alertContent').html(HTMLHead + HTMLTable);
                    //break;
                }
            }
        }

        return HTMLHead + HTMLTable;
    };

    return <React.Fragment>{parse(htmlData())}</React.Fragment>;
};

export default AlertDetailsComponent;
